var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hitchRideSettleRule"},[_c('custom-org-tree',{attrs:{"url":"/api/v1/manage/hitchRide/commissionRule"},on:{"selected":_vm.handleSelect}}),_c('div',{staticClass:"hitchRideSettleRule-content"},[_c('rakeRulesForm',{attrs:{"cityData":{ ..._vm.selectCity }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }